export default {
  props: ["id"],
  data() {
    return {
      observer: null,
      showImageModal: false,
      selectedImage: {
        src: '',
        alt: ''
      }
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.initializeAnimations();
    document.addEventListener('keydown', this.handleEscapeKey);
  },
  methods: {
    goToContact() {
      this.$router.push('/contact');
    },
    openImageModal(imageSrc, imageAlt) {
      this.selectedImage = {
        src: imageSrc,
        alt: imageAlt
      };
      this.showImageModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeImageModal() {
      this.showImageModal = false;
      this.selectedImage = { src: '', alt: '' };
      document.body.style.overflow = 'auto';
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.showImageModal) {
        this.closeImageModal();
      }
    },
    initializeAnimations() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");

              const delay =
                Array.from(entry.target.parentNode.children).indexOf(
                  entry.target
                ) * 100;
              setTimeout(() => {
                entry.target.style.transitionDelay = `${delay}ms`;
              }, 0);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: "0px 0px -50px 0px",
        }
      );

      this.$nextTick(() => {
        const animatedElements =
          document.querySelectorAll(".animate-on-scroll");
        animatedElements.forEach((el) => {
          this.observer.observe(el);
        });
      });
    },
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    document.removeEventListener('keydown', this.handleEscapeKey);
    document.body.style.overflow = 'auto';
  },
};